module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('Vheader'), _vm._v(" "), _c('div', {
    staticClass: "page"
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "animated flipInY"
    }
  }, [_c('router-view')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ea730984!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 63
// module chunks = 1